import Navbar from "../components/Navbar";
import Footer from '../components/Footer';
import Initiatives from '../components/Initiatives';
import BackToTop from '../components/BackToTop';
import PageHeader from "../components/PageHeader";
import Landing from "../components/Landing";

export default function Events() {
    return (
        <>
            <Navbar />
            {/* <PageHeader title="ክንውን" path="/ክንውን" name="ክንውኖች" /> */}
            {/* <Landing /> */}
            <Initiatives />
            <Footer />
            <BackToTop />
        </>
    );
}